<template>
  <div  class="user_item pos-rel">
    <v-list-tile @click="showDetails">
      <v-layout align-center row class="caption" :class="paddingClass">
        <ListIcon
        >
          <v-icon
            color="primary"
          >
            folder
          </v-icon>
        </ListIcon>
        <v-flex xs12 md4>
          {{userName}}
        </v-flex>
        <v-flex xs3 v-html="userMail" class="hidden-sm-and-down">
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{user.status_txt}}
        </v-flex>
        <v-flex xs2 class="hidden-sm-and-down">
          {{clientName}}
        </v-flex>
      </v-layout>
    </v-list-tile>
    <userMenu :status="user.status" :userId="user.id" :role="user.role" />
    <v-divider v-if="!isLast"></v-divider>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import userMenu from './UsersMenu.vue';
import ListIcon from '../common/ListIcon.vue';

export default {
  name: 'user-item',
  props: ['user', 'index'],
  components: {
    ListIcon,
    userMenu,
  },
  computed: {
    ...mapGetters('users', [
      'usersList',
    ]),
    userMail() {
      const adressEmail = this.user.email;
      const emailItem = `<a href="mailto:${adressEmail}">${adressEmail}</a>`;
      return adressEmail ? emailItem : 'Brak';
    },
    clientName() {
      const clientName = this.user.client_name;
      return clientName || 'Brak';
    },
    userName() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },
    isLast() {
      return this.usersList.length - 1 === this.index;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-2';
    },
  },
  methods: {
    ...mapActions('users', [
      'setActiveListItem',
    ]),
    setActive() {
      const userData = {
        id: this.user.id,
        status_txt: this.user.is_active_txt,
        name: this.userName,
      };
      this.setActiveListItem(userData);
    },
    showDetails() {
      this.setActive();
      this.$router.push(`/uzytkownik/${this.user.id}`);
    },
  },
};
</script>

<style scoped>
  .user_item {
    position: relative;
  }
</style>
